/**
 * Format a precheck refusal or legacy CDEK registration error for the final form.
 * @param {object | undefined} response
 * @param {(key: string) => string} t
 * @returns {string}
 */
export function formatInvoiceCreationFailure(response, t) {
    if (response?.error === 'international_restriction_forbidden') {
        const issues = Array.isArray(response?.details?.issues) ? response.details.issues : [];
        const reasons = issues.filter(issue => typeof issue?.reason === 'string' && issue.reason.trim())
            .map(issue => {
                const place = issue.package_number ? `${t('place_word')} #${issue.package_number}` : '';
                const name = typeof issue.name === 'string' ? issue.name.trim() : '';
                return [...[place, name].filter(Boolean), issue.reason.trim()].join(': ');
            });
        return [t('invoice_restriction_forbidden'), ...new Set(reasons)].join('\n');
    }
    if (response?.error === 'international_restriction_check_unavailable') {
        return t('invoice_restriction_unavailable');
    }
    if (response?.error === 'invoice_creation_unknown') {
        return t('invoice_creation_unknown');
    }
    if (typeof response?.restriction_message === 'string' && response.restriction_message.trim()) {
        return response.restriction_message.trim();
    }
    const requests = Array.isArray(response?.requests) ? response.requests : [];
    const messages = requests.flatMap(request => Array.isArray(request?.errors) ? request.errors : [])
        .map(error => error?.message || error?.code).filter(message => typeof message === 'string' && message.trim());
    return messages.join('\n') || t('invoice_creation_failed');
}
